import script from "./DefaultCallButton.vue?vue&type=script&setup=true&lang=js"
export * from "./DefaultCallButton.vue?vue&type=script&setup=true&lang=js"

import "./DefaultCallButton.vue?vue&type=style&index=0&id=db13267c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-db13267c"]])

export default __exports__